import type { SeriesTemplateAssessmentAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import AssessmentQ from './AssessmentQ'
import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import SeriesTemplateQ from './SeriesTemplateQ'

const SeriesTemplateAssessmentQ = {
  ...makeQueryModelV2<SeriesTemplateAssessmentAttributes>('series_template_assessment')([
    'id',
    'series_template_id',
    'assessment_id',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    Assessment: {
      query: AssessmentQ,
      foreignKey: AssessmentQ.id,
      sourceKey: SeriesTemplateAssessmentQ.assessment_id,
    },
    SeriesTemplate: {
      query: SeriesTemplateQ,
      foreignKey: SeriesTemplateQ.id,
      sourceKey: SeriesTemplateAssessmentQ.series_template_id,
    },
  }),

  where: (
    {
      paranoid = true,
      seriesTemplateId,
      include = [],
      groupBy = null,
      order = null,
      limit = null,
    }: {
      paranoid?: boolean
      seriesTemplateId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SeriesTemplateAssessmentAttributes> => SQL`
        FROM ${SeriesTemplateAssessmentQ}
        ${includeAssociationsToSql(SeriesTemplateAssessmentQ, include)}
        WHERE
            ${
              seriesTemplateId != null
                ? SQL`${SeriesTemplateAssessmentQ.series_template_id} = ${seriesTemplateId} AND`
                : SQL``
            }
            ${paranoid ? SQL`${SeriesTemplateAssessmentQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,
}

export default SeriesTemplateAssessmentQ
